module.exports = __webpack_public_path__ + "static/media/mountain5.cc5f35a6.jpg";